import { Injectable, inject, signal } from '@angular/core';

import { BehaviorSubject, Observable, catchError, first, of } from 'rxjs';

import { SharedFeaturesApiService } from '../http/shared-features-api.service';
import { UserService } from '../user/user.service';
import { RegistrationInformation } from './registration-info.models';

@Injectable({
    providedIn: 'root',
})
export class RegistrationInfoService {
    private readonly apiService = inject(SharedFeaturesApiService);
    private readonly user = inject(UserService);

    private readonly registrationInformationEvents = new BehaviorSubject<RegistrationInformation | null>(null);
    private readonly regInfo = signal<RegistrationInformation | null>(null);

    get registrationInformation(): Observable<RegistrationInformation | null> {
        return this.registrationInformationEvents;
    }

    get info(): RegistrationInformation | null {
        return this.regInfo();
    }

    /** @internal */
    load() {
        if (this.user.isAuthenticated) {
            this.apiService
                .get('registrationinfo')
                .pipe(
                    first(),
                    catchError(() => {
                        const defaultInfo: RegistrationInformation = {
                            date: '',
                            daysRegistered: -1,
                        };
                        return of(defaultInfo);
                    }),
                )
                .subscribe((info: RegistrationInformation) => {
                    this.registrationInformationEvents.next(info);
                    this.regInfo.set(info);
                });
        }
    }
}
